var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-list',{attrs:{"title":"Transaksi Berhasil","data-url":"/api/v1/po/success","data-size":"10","printUrl":"/po/print","previewUrl":"/po/preview/:id:","dataHeaders":_vm.tHeaders}})}
var staticRenderFns = []

export { render, staticRenderFns }